import { render } from "./Tab1View.vue?vue&type=template&id=4bf9e25c&scoped=true"
import script from "./Tab1View.vue?vue&type=script&lang=js"
export * from "./Tab1View.vue?vue&type=script&lang=js"

import "./Tab1View.vue?vue&type=style&index=0&id=4bf9e25c&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf9e25c"]])

export default __exports__